import React from 'react'
import ElectronicTaxBureau from './index.js'

/** 授权旧版本引导页 */
const GuideElectronicTaxBureauOld = (props) => {
  return <ElectronicTaxBureau NEW_AUTH={false} {...props} />
}

export default GuideElectronicTaxBureauOld